// src/api.js

import axios from 'axios';


const params = new URLSearchParams(window.location.search);
const token = params.get('token');// 获取 token 从 URL 查询参数

// 使用相对路径作为 baseURL
const axiosInstance = axios.create({
  baseURL: '/api-evimed/FineScreenController/TopicAnalysisController/reporting',
  timeout: 90000, // 设置请求超时为10秒
  headers: {
    'Content-Type': 'application/json',
  },
});
axiosInstance.interceptors.request.use(
  config => {
    // const token = '1305a2f7d1b1249a7abe941980e8b4156';
    if (token) {
      config.headers['Token'] = token;
    }
    return config;
  },
  error => Promise.reject(error)
);
// 定义具体的 API 请求函数
export const getCoAuthorshipAnalysis = (pid, words, language) => {
  return axiosInstance.get('/CoAuthorshipAnalysis', {
    params: { pid, words, language },
  });
};
export const getInstitutionalAnalysis = (pid, words, language) => {
  return axiosInstance.get('/InstitutionalAnalysis', {
    params: { pid, words, language },
  });
};
export const getkeywordAnalysis = (pid, words, language) => {
  return axiosInstance.get('/keywordAnalysis', {
    params: { pid, words, language },
  });
};
export const getCitationAnalysis = (pid, words, language) => {
  return axiosInstance.get('/CitationAnalysis', {
    params: { pid, words, language },
  });
};
export default axiosInstance;

// import axios from 'axios';

// // 配置基础 URL
// // const API_BASE_URL = '/api-evimed/FineScreenController/TopicAnalysisController/reporting';

// // 创建 axios 实例
// const axiosInstance  = axios.create({
//   baseURL: '/api-evimed/FineScreenController/TopicAnalysisController/reporting',
//   timeout: 10000, // 请求超时设置
//   headers: {
//     'Content-Type': 'application/json;charset=UTF-8'
//     // 如果需要其他头部信息，可以在这里添加
//   },
// });

// // // 添加请求拦截器
// axiosInstance.interceptors.request.use(
//   config => {
//     const token = '1f45ef14119014e6fbcdd9162ddfdd9b7';
//     if (token) {
//       config.headers['Token'] = `${token}`;
//     }
//     return config;
//   },
//   error => Promise.reject(error)
// );

// // 添加响应拦截器
// axiosInstance.interceptors.response.use(
//   response => response,
//   error => Promise.reject(error)
// );

// export default axiosInstance;